/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MenuItem/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'



/** @type {import('Simple/types.js').View} */
export default function MenuItem({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Tabs/Content/Empty/MenuItem"
  
}) {
let menuItemTextValueData = fromData.useDataValue({ viewPath,
context: 'menu_item',
path: 'text',
})
let selectedSubmenuTabIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'submenu_tab_id',
})
let menuItemIdValueData = fromData.useDataValue({ viewPath,
context: 'menu_item',
path: 'id',
})
let aggregateData = fromAggregate.equals(selectedSubmenuTabIdValueData, menuItemIdValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 size="medium"
 data="menu_item.text"
 text={menuItemTextValueData}
 onClick={onClick}
 data="selected.submenu_tab_id"
 data="menu_item.id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
/>
{children}
</React.Fragment>)
}